import { render, staticRenderFns } from "./ItemsDataTable.vue?vue&type=template&id=fc03acac&"
import script from "./ItemsDataTable.vue?vue&type=script&lang=js&"
export * from "./ItemsDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports